import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Card, CardHeader, Divider } from '@material-ui/core';
import CollapsibleListRow from './CollapsibleListRow';
import { Virtuoso } from 'react-virtuoso';
import useTableStyles from './useTableStyles';
import MobileTableHead from './MobileTableHead';
import { DashboardHelpers } from 'utils';

const MobileTable = ({ title, customHeader, tableHeader, data, selectRow, sortFunc }) => {
  const classes = useTableStyles();

  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('');

  const handleRequestSort = (event, property) => {
    if (setOrderBy) {
      setOrderBy(property);
    }
    if (setOrder) {
      setOrder(order === 'desc' ? 'asc' : 'desc');
    }
  };

  const handleClick = (event, item) => {
    selectRow(event, item);
  };

  const sortedData = sortFunc(tableHeader, order, orderBy, data);

  return (
    <Card>
      {customHeader(title)}
      <Divider />
      <MobileTableHead
        classes={classes}
        headers={tableHeader}
        order={order}
        orderBy={orderBy}
        onRequestSort={handleRequestSort}
      />
      <Virtuoso
        style={{ height: '52vh' }}
        data={sortedData}
        itemContent={(index, row) => {
          return (
            <CollapsibleListRow
              data={row}
              tableHeader={tableHeader}
              viewItem={(event) => {
                event.stopPropagation();
                handleClick(event, row);
              }}
            />
          );
        }}
      />
    </Card>
  );
};

MobileTable.propTypes = {
  title: PropTypes.string,
  customHeader: PropTypes.func,
  tableHeader: PropTypes.arrayOf(
    PropTypes.shape({
      alias: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
      sortable: PropTypes.bool.isRequired,
      mobilePreview: PropTypes.bool,
      mobileInfo: PropTypes.bool,
      format: PropTypes.oneOf(['date', 'string', 'number']),
      dataAlias: PropTypes.string.isRequired,
      className: PropTypes.string,
      dataRender: PropTypes.func,
    })
  ).isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    })
  ),
  selectRow: PropTypes.func.isRequired,
  sortFunc: PropTypes.func,
};

MobileTable.defaultProps = {
  title: '',
  customHeader: (title) => <CardHeader title={title} />,
  tableHeader: undefined,
  data: undefined,
  sortFunc: (tableHeader, order, orderBy, data) => {
    return DashboardHelpers.sortTableFunction(tableHeader, order, orderBy, data);
  },
};

export default MobileTable;
